var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.849,
    height: 11.835,
    viewBox: "0 0 10.849 11.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3178",
    "data-name": "Group 3178",
    transform: "translate(0.37 0.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3363",
    "data-name": "Path 3363",
    d: "M15.255,7.243a.97.97,0,0,0-.848-.493H8.736a.989.989,0,0,0-.986.986V15.38a.975.975,0,0,0,.078.384l-.078.109a.97.97,0,0,0,.848.493h5.671a.989.989,0,0,0,.986-.986V7.736a.975.975,0,0,0-.078-.384Z",
    transform: "translate(-7.75 -6.75)",
    fill: "#2fdf84"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3179",
    "data-name": "Group 3179",
    transform: "translate(2.835 2.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3364",
    "data-name": "Path 3364",
    d: "M20.393,18.886v-7.15a.986.986,0,0,0-.986-.986H13.736a.986.986,0,0,0-.986.986v7.15a.986.986,0,0,0,.986.986h5.671A.986.986,0,0,0,20.393,18.886Z",
    transform: "translate(-12.75 -10.75)",
    fill: "#f3f3f1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3180",
    "data-name": "Group 3180",
    transform: "translate(0.37 0.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3365",
    "data-name": "Path 3365",
    d: "M8.86,15.873l.078-.109a.975.975,0,0,1-.078-.384V7.736a.989.989,0,0,1,.986-.986H8.736a.989.989,0,0,0-.986.986V15.38a.975.975,0,0,0,.078.384l-.078.109a.97.97,0,0,0,.848.493h1.11A.97.97,0,0,1,8.86,15.873Z",
    transform: "translate(-7.75 -6.75)",
    fill: "#00b871"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3181",
    "data-name": "Group 3181",
    transform: "translate(2.835 2.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3366",
    "data-name": "Path 3366",
    d: "M13.86,18.886v-7.15a.986.986,0,0,1,.986-.986h-1.11a.986.986,0,0,0-.986.986v7.15a.986.986,0,0,0,.986.986h1.11A.986.986,0,0,1,13.86,18.886Z",
    transform: "translate(-12.75 -10.75)",
    fill: "#d5dbe1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3182",
    "data-name": "Group 3182",
    transform: "translate(4.808 7.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3367",
    "data-name": "Path 3367",
    d: "M16.75,21.5h3.7v.74h-3.7Z",
    transform: "translate(-16.75 -21.5)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3183",
    "data-name": "Group 3183",
    transform: "translate(4.808 9.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3368",
    "data-name": "Path 3368",
    d: "M16.75,25.5h3.7v.74h-3.7Z",
    transform: "translate(-16.75 -25.5)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3184",
    "data-name": "Group 3184",
    transform: "translate(4.808 5.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3369",
    "data-name": "Path 3369",
    d: "M16.75,18h3.7v.74h-3.7Z",
    transform: "translate(-16.75 -18)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3185",
    "data-name": "Group 3185",
    transform: "translate(4.808 3.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3370",
    "data-name": "Path 3370",
    d: "M16.75,14h3.7v.74h-3.7Z",
    transform: "translate(-16.75 -14)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3186",
    "data-name": "Group 3186",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3371",
    "data-name": "Path 3371",
    d: "M8.726,16.356h-.37A1.357,1.357,0,0,1,7,15V7.356A1.357,1.357,0,0,1,8.356,6h5.671a1.347,1.347,0,0,1,1.17.681L15.38,7l-.644.365-.182-.322a.6.6,0,0,0-.527-.306H8.356a.617.617,0,0,0-.616.616V15a.617.617,0,0,0,.616.616h.37Z",
    transform: "translate(-7 -6)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3187",
    "data-name": "Group 3187",
    transform: "translate(2.466 1.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3372",
    "data-name": "Path 3372",
    d: "M19.027,19.862H13.356A1.357,1.357,0,0,1,12,18.506v-7.15A1.357,1.357,0,0,1,13.356,10h5.671a1.357,1.357,0,0,1,1.356,1.356v7.15A1.357,1.357,0,0,1,19.027,19.862ZM13.356,10.74a.617.617,0,0,0-.616.616v7.15a.617.617,0,0,0,.616.616h5.671a.617.617,0,0,0,.616-.616v-7.15a.617.617,0,0,0-.616-.616Z",
    transform: "translate(-12 -10)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.71011f1f10234a72d39f8e0aad1f3c62.svg";
export { ForwardRef as ReactComponent };